import { render, staticRenderFns } from "./ColumnManager.vue?vue&type=template&id=08dd49a4&scoped=true&"
import script from "./ColumnManager.vue?vue&type=script&lang=js&"
export * from "./ColumnManager.vue?vue&type=script&lang=js&"
import style0 from "./ColumnManager.vue?vue&type=style&index=0&id=08dd49a4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08dd49a4",
  null
  
)

export default component.exports